import { Widget } from '../../widget';
import WidgetButtons from '../../widget-buttons';
import { VolatilitySurfaceMarkingContent } from './volatility-surface-marking-content';
import { IVolatilitySurfaceMarkingWidgetProps } from './types';

const VolatilitySurfaceMarkingWidget = (props: IVolatilitySurfaceMarkingWidgetProps) => {
  const { widget, actions } = props;

  return (
    <Widget cardKey={widget.key}>
      <Widget.Header>
        <Widget.Title title={widget.title} />
        <Widget.Buttons>
          <WidgetButtons
            widget={widget}
            actions={actions}
            permissions={{
              canDelete: false,
              canDuplicate: false,
            }}
          />
        </Widget.Buttons>
      </Widget.Header>
      <Widget.Content>
        <VolatilitySurfaceMarkingContent />
      </Widget.Content>
      <Widget.Footer />
    </Widget>
  );
};

export default VolatilitySurfaceMarkingWidget;
